import { GzSideMenuWebComponent } from './component/GzSideMenuWebComponent';
import { WEB_COMPONENT_GZ_SIDE_MENU } from '../../webcomponents.constants';

export { GzSideMenuWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_SIDE_MENU, GzSideMenuWebComponent);

/**
 * Examples:
 * Basic side menu =>
 *  <gz-side-menu>
 *    <ul>
 *      <li>Item one</li>
 *      <li>Item two</li>
 *    </ul>
 *  </gz-side-menu>
 *
 *  Basic side menu that closes by clicking outside of it =>
 *  <gz-side-menu closeOnClickOutside>
 *    <ul>
 *      <li>Item one</li>
 *      <li>Item two</li>
 *    </ul>
 *  </gz-side-menu>
 *
 * Left-aligned side menu =>
 *  <gz-side-menu menuposition="left">
 *    <ul>
 *      <li>Item one</li>
 *      <li>Item two</li>
 *    </ul>
 *  </gz-side-menu>
 *
 *  Left-aligned side menu with wide variant =>
 *  <gz-side-menu menuwidth="560" menuposition="left">
 *    <ul>
 *      <li>Item one</li>
 *      <li>Item two</li>
 *    </ul>
 *  </gz-side-menu>
 *
 */
